module.exports = __webpack_public_path__ + "img/16.5783acd5.jpg";